import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageToolbar, PageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useActionRegistryGlobalHandler, useActionRegistryNavigation } from "@sprout/list-navigation";
import { stringifyUrl } from "query-string";
import { TeamMemberLevel, UserType, useApp_CreatePostMutation, WellKnownTopic } from "sprout-graphql";
import { LeafLine } from "sprout-ui-icons";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useHistory } from "react-router-dom";
import { getItemUrl } from "sprout-lib";
const ProfilePageUserToolbar = (props)=>{
    const { user  } = props;
    const { memberLevel , username , id , type  } = user;
    const currentUser = useCurrentUser();
    const isOwnerOrAdmin = memberLevel === TeamMemberLevel.Owner || memberLevel === TeamMemberLevel.Admin;
    const isCurrentUser = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) === id;
    useActionRegistryNavigation("NEW_TOPIC", stringifyUrl({
        url: "/new-tree",
        query: {
            workspace: type === UserType.Team ? username : undefined
        }
    }), {
        skip: !isOwnerOrAdmin && !isCurrentUser
    });
    const [createPost] = useApp_CreatePostMutation();
    const history = useHistory();
    const showSnackbar = useSnackbar();
    useActionRegistryGlobalHandler("ADD_DRAFT_POST", ()=>{
        createPost({
            variables: {
                inside: WellKnownTopic.Profile
            }
        }).then(({ data  })=>{
            var ref;
            const item = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
            if (item) history.push(getItemUrl(item), {
                focusDescriptionEditor: true
            });
        }).catch(()=>{
            showSnackbar.error();
        });
        return true;
    }, {
        skip: !isCurrentUser
    });
    return /*#__PURE__*/ _jsxs(RenderIfChildExists, {
        component: /*#__PURE__*/ _jsx(PageToolbar, {
            $stickyWithBottomNavigation: true
        }),
        children: [
            isCurrentUser && /*#__PURE__*/ _jsx(PageToolbarItem, {
                label: "Leaf",
                icon: LeafLine,
                action: "ADD_DRAFT_POST"
            }),
            (isOwnerOrAdmin || isCurrentUser) && /*#__PURE__*/ _jsx(PageToolbarItem, {
                action: "NEW_TOPIC"
            })
        ]
    });
};
export default ProfilePageUserToolbar;
